import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { init } from 'echarts';

import getOptions from './GroupedTreemapConfig';

function GroupedTreemap({ config, data, height = '350px' }) {
  const theme = useSelector((state) => state.global.theme);

  const chartContainerRef = useRef(null);
  const [chart, setChart] = useState(null);

  useEffect(() => {
    if (chart) {
      chart.resize();
      chart.setOption(getOptions({ config, data, theme }), {
        notMerge: true,
      });
    }
  }, [chart, config, data, theme]);

  useEffect(() => {
    if (!chartContainerRef.current || !chart) return;

    const resizeObserver = new window.ResizeObserver(() => {
      chart.resize();
    });

    resizeObserver.observe(chartContainerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [chart]);

  useEffect(() => {
    const chartInstance = init(chartContainerRef.current);
    setChart(chartInstance);

    return () => {
      chartInstance.dispose();
    };
  }, []);

  return (
    <div>
      <div ref={chartContainerRef} style={{ height, width: '100%', minHeight: '350px' }} />
    </div>
  );
}

export default GroupedTreemap;
